export const tr_find_the_perfect_gift = {
	DE: 'Finde das perfekte Geschenk',
	EN: 'Find the perfect Gift',
	FR: 'Trouver le cadeau idéal',
};
